import QuestionHeader from "../question-header";
import SelectableOption from "../selectable-option";

export const MultiSelectQuestion = ({ question, value = [], onChange, error, helperText }) => {
  const toggleOption = (option) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <div className="flex flex-col min-h-0 space-y-6">
      <QuestionHeader label={question.label} required={question.required} description={question.description} />

      <div className="flex-1 min-h-0 overflow-y-auto space-y-3 pr-2">
        {question.options.map((option) => (
          <SelectableOption
            key={option}
            label={option.text}
            selected={value.includes(option.id)}
            onSelect={() => toggleOption(option.id)}
            type="checkbox"
            error={error}
          />
        ))}
      </div>

      {helperText && <p className="text-sm text-error">{helperText}</p>}
    </div>
  );
};
